import useCancelableQuery from '../../core/hooks/apollo/useCancelableQuery';
import useDetailsForCategories from '../../core/queries/useDetailsForCategories';
import type { ProductBestAvailabilityFilter } from '../components/ProductList/context/ProductListOptionsContext';
import { productRootCategoriesQuery } from './productListQuery';
import type {
    RootCategoriesQueryResult,
    FilterList,
    ProductState,
} from './types';

const defaultRootCategoriesQueryResult: RootCategoriesQueryResult = {
    rootCategories: {
        categories: [],
    },
};

const useProductListRootCategories = ({
    variables,
    skip,
    rootCategoryId,
    categoryId,
    rootTree,
}: {
    variables: {
        language: 'en' | 'de' | 'fr' | 'it';
        store: string;
        filters: FilterList[];
        bicycleId?: string;
        search?: string;
        minPrice?: number;
        states: ProductState[];
        maxPrice?: number;
        vehicleId?: string;
        categoryId?: string;
        preorderSeasonId?: number;
        includeExcludedCategories?: boolean;
        bestAvailability?: ProductBestAvailabilityFilter;
    };
    rootCategoryId?: string;
    categoryId?: string;
    skip?: boolean;
    rootTree?: boolean;
}) => {
    const isRootCategory = !rootCategoryId && !!categoryId;

    const {
        loading,
        data: {
            rootCategories: { categories },
        } = defaultRootCategoriesQueryResult,
        error,
    } = useCancelableQuery<RootCategoriesQueryResult>(
        productRootCategoriesQuery,
        {
            variables: {
                ...variables,
                categoryId: rootTree ? undefined : rootCategoryId,
            },
            skip: skip || isRootCategory,
            fetchPolicy: 'cache-first',
        },
        true
    );

    const categoryDetails = useDetailsForCategories(
        categories.map(({ category }) => category.id)
    );

    if (error) {
        throw error;
    }

    return {
        loading: loading || isRootCategory,
        categories: categoryDetails.map(category => ({
            category: category,
            total:
                categories.find(item => item.category.id === category.id)
                    ?.total ?? 0,
        })),
    };
};

export default useProductListRootCategories;
